import { render, staticRenderFns } from "./BlockDialog.vue?vue&type=template&id=1b5f604a&scoped=true"
import script from "./BlockDialog.vue?vue&type=script&lang=js"
export * from "./BlockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f604a",
  null
  
)

export default component.exports